import { useTheme } from '@mui/material';
import { Pill } from '@portals/core/src/components/Pill/Pill';
import { Typography } from '@portals/core/src/components/Typography/Typography';
import { Close } from '@portals/icons';
import { getFixedT } from 'i18next';
import React, { Fragment, useCallback } from 'react';

import { getStyles } from './AutocompletePills.style';

interface Option {
  value: number;
  label: string;
}

interface Props {
  options: Array<Option>;
  onDelete: (optionKey: number) => void;
}

const t = getFixedT(null, 'core-immobilien');

const AutocompletePills: React.FC<Props> = ({ options, onDelete }: Props) => {
  const theme = useTheme();
  const styles = getStyles(theme);

  const handleClick = useCallback(
    (value: number) => () => {
      if (onDelete) {
        onDelete(value);
      }
    },
    [onDelete]
  );

  return (
    <>
      {options.slice(0, 2).map((option) => (
        <Fragment key={option.value}>
          <Pill
            component="button"
            sx={styles.pill}
            size="small"
            label={option.label}
            onClick={handleClick(option.value)}
            deleteIcon={<Close />}
            aria-label={t('autocomplete.pill.ariaLabel', { city: option.label })}
          />
        </Fragment>
      ))}
      {options.length > 2 ? (
        <Typography variant="button" key={3} sx={styles.count} className="selected-city-counts">{`+${
          options.length - 2
        }`}</Typography>
      ) : null}
    </>
  );
};

AutocompletePills.displayName = 'AutocompletePills';

export default AutocompletePills;
